import { render, staticRenderFns } from "./AppAuthentication.vue?vue&type=template&id=47bb5e6c&scoped=true"
import script from "./AppAuthentication.vue?vue&type=script&lang=ts"
export * from "./AppAuthentication.vue?vue&type=script&lang=ts"
import style0 from "./AppAuthentication.vue?vue&type=style&index=0&id=47bb5e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb5e6c",
  null
  
)

export default component.exports